import {
  requestWreathOrderHistory,
  requestCompanyWreathOrderHistory
} from "../apis/cal_api";

const state = {
  // 총 화환 통계
  totalOrderHistoryInfo: {
    totalOrderCount: 0,
    totalOrderAmount: 0,
    totalOrderPayback: 0,
    totalMangedAmount: 0
  },
  orderHistoryList: [],
  orderHistoryPage: null,
  orderHistoryPageTotal: 0,
  orderHistoryTotalElements: 0,

  // 업체당 주문 통계
  companyTotalOrderHistoryInfo: {
    companyName: "",
    totalOrderCount: 0,
    totalOrderAmount: 0,
    totalOrderPayback: 0,
    totalMangedAmount: 0
  },
  companyOrderHistoryList: [],
  companyOrderHistoryPage: null,
  companyOrderHistoryPageTotal: 0,
  companyOrderHistoryTotalElements: 0
};
const getters = {
  getOrderHistoryList(state) {
    return state.orderHistoryList;
  },
  getTotalOrderHistoryInfo(state) {
    return state.totalOrderHistoryInfo;
  },

  getOrderHistoryPage(state) {
    return state.orderHistoryPage;
  },

  getOrderHistoryPageTotal(state) {
    return state.orderHistoryPageTotal;
  },

  getCompanyOrderHistoryList(state) {
    return state.companyOrderHistoryList;
  },
  getCompanyTotalOrderHistoryInfo(state) {
    return state.companyTotalOrderHistoryInfo;
  },

  getCompanyOrderHistoryPage(state) {
    return state.companyOrderHistoryPage;
  },

  getCompanyOrderHistoryPageTotal(state) {
    return state.companyOrderHistoryPageTotal;
  }
};

const mutations = {
  SET_ORDER_HISTORY(state, data) {
    state.orderHistoryList = data.orderHistoryList;
    state.totalOrderHistoryInfo = data.totalOrderHistoryInfo;
    state.orderHistoryPage = data.page;
    state.orderHistoryPageTotal = data.pageTotal;
  },

  SET_COMPANY_ORDER_HISTORY(state, data) {
    state.companyOrderHistoryList = data.companyOrderHistoryList;
    state.companyTotalOrderHistoryInfo = data.companyTotalOrderHistoryInfo;
    state.companyOrderHistoryPage = data.page;
    state.companyOrderHistoryPageTotal = data.pageTotal;
  }
};

const actions = {
  // 총 화환 통계 불러오기
  async REQUEST_WREATH_ORDER_HISTORY({ commit }, payload) {
    try {
      if (!payload.target) {
        return;
      }
      const res = await requestWreathOrderHistory(payload);

      const {
        data: {
          result,
          resultFuneralList,
          page,
          pageTotal,
          totalOrderHistoryInfo
          // totalOrderCount,
          // totalOrderAmount,
          // totalOrderPayback,
          // totalMangedAmount
        }
      } = res;

      if (result !== "success") {
        return;
      }

      const orderHistoryList = resultFuneralList.map(funeral => {
        const shopPayParams = funeral.ShopPayParams;
        const orderAmount = shopPayParams?.reduce(
          (accumulator, obj) => accumulator + parseInt(obj.price),
          0
        );
        const managedCount = shopPayParams.filter(
          v => v.name !== "영정바구니" && v.name !== "영정바구니 고급"
        )?.length;

        const result = {
          id: funeral.id,
          TVM_GRP: funeral.TVM_GRP,
          name: funeral.name,
          addr: funeral.addr,
          orderCount: shopPayParams?.length,
          orderAmount,
          orderPayback: Math.floor(
            orderAmount * (funeral.name === "여수경산장례식장" ? 0.3 : 0.2)
          ),
          managedCount,
          mangedAmount: managedCount * 10000
        };

        console.log(result);

        return result;
      });

      // const totalOrderCount = orderHistoryList.reduce(
      //   (accumulator, obj) => accumulator + parseInt(obj.orderCount),
      //   0
      // );
      // const totalOrderAmount = orderHistoryList.reduce(
      //   (accumulator, obj) => accumulator + parseInt(obj.orderAmount),
      //   0
      // );
      // const totalOrderPayback = orderHistoryList.reduce(
      //   (accumulator, obj) => accumulator + parseInt(obj.orderPayback),
      //   0
      // );
      // const totalMangedAmount = orderHistoryList.reduce(
      //   (accumulator, obj) => accumulator + parseInt(obj.mangedAmount),
      //   0
      // );

      // const totalOrderHistoryInfo = {
      //   totalOrderCount,
      //   totalOrderAmount,
      //   totalOrderPayback,
      //   totalMangedAmount
      // };

      commit("SET_ORDER_HISTORY", {
        orderHistoryList,
        totalOrderHistoryInfo,
        page,
        pageTotal
      });
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // 업체 내 화환 주문 건 수 불러오기
  async REQUEST_COMPANY_WREATH_ORDER_HISTORY({ commit }, payload) {
    try {
      const res = await requestCompanyWreathOrderHistory(payload);

      const {
        data: { result, resultFuneral, resultOrderList, page, pageTotal }
      } = res;

      if (result !== "success") {
        return;
      }

      console.log(resultOrderList, pageTotal);

      const totalOrderCount = resultOrderList?.length;

      const totalOrderAmount = resultOrderList?.reduce(
        (accumulator, obj) => accumulator + parseInt(obj.price),
        0
      );

      const totalOrderPayback = Math.floor(
        totalOrderAmount *
          (resultFuneral.name === "여수경산장례식장" ? 0.3 : 0.2)
      );

      const managedCount = resultOrderList.filter(
        v => v.name !== "영정바구니" && v.name !== "영정바구니 고급"
      )?.length;

      const totalMangedAmount = managedCount * 10000;

      const companyTotalOrderHistoryInfo = {
        companyName: resultFuneral.name,
        totalOrderCount,
        totalOrderAmount,
        totalOrderPayback,
        totalMangedAmount
      };

      commit("SET_COMPANY_ORDER_HISTORY", {
        companyOrderHistoryList: resultOrderList,
        companyTotalOrderHistoryInfo,
        page,
        pageTotal
      });
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
